<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="addUser.info.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey mb-4" translate="addUser.info.subtitle"></p>

    <div [formGroup]="form" novalidate>
      <div class="field">
        <fino-input
          formControlName="email"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>

      <div class="field">
        <fino-input
          formControlName="firstName"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>

      <div class="field">
        <fino-input
          formControlName="lastName"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        [disabled]="formNotTouched"
        class="has-text-weight-bold mr-1"
        (click)="submit()"
        fino-button
        label="addUser.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="addUser.abort"
      ></button>
    </div>
  </div>
</div>
